export default __webpack_public_path__ + "static/media/YogaClubBG.2f70700f.png";